import { Component, Input } from '@angular/core';
import { EventViewModel } from '../../../models-views/event.view.model';
import { ActivatedRoute } from '@angular/router';
import { InvoiceResponseModel } from '../../../models/event.model';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { CetInvoicesModalComponent } from './cet-invoices-modal/cet-invoices-modal.component';
import { CetInvoiceDetailsComponent } from '../../cet-invoice-details/cet-invoice-details.component';
import { environment } from '../../../../environments/environment';
import { CetVendorDetailsComponent } from '../cet-vendor-details/cet-vendor-details.component';

@Component({
  selector: 'app-cet-invoices',
  standalone: false,
  templateUrl: './cet-invoices.component.html',
  styleUrl: './cet-invoices.component.scss'
})
export class CetInvoicesComponent {
  rfqRef?: NzModalRef;
  @Input('eventId') eventId: string | null = null;
  invoiceList = [];
  invoiceResponseModel = new BehaviorSubject<InvoiceResponseModel>(new InvoiceResponseModel())
  loading:boolean = false
  cetInvoicModalRef:any
  searchChange$ = new Subject();
  searchText: string ;
  constructor(private modalService: NzModalService,  private vm: EventViewModel,  private route: ActivatedRoute
  ) {
    this.vm.cetInvoicesComponent = this
     this.searchChange$.pipe(debounceTime(500)).subscribe(name => {
              this.getData()
        });
  }

  ngOnInit(): void {
    this.vm.subscribeToInvoice(this.invoiceResponseModel)

  }

   onSearch() {
    this.searchChange$.next(this.searchText);
  }

  getData(){
    this.loading = true
    this.vm.getInvoices(1, 100, 'cetInvoicesComponent', this.eventId, this.searchText)
  }

  invoiceRecieved(){
    this.invoiceList = this.invoiceResponseModel.value.results
    this.loading = false
  }

  onAdd(){
   this.cetInvoicModalRef = this.modalService.create({
      nzTitle: 'Add Bill/Invoice',
      nzContent: CetInvoicesModalComponent,
      nzFooter:null,
      nzData: {
      eventId: this.eventId // 👈 This is how you pass data
     },
      nzWidth: '800px',
      nzStyle:{top:'50px'},
      nzClosable: true,
      nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
    });

    this.cetInvoicModalRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });
  }

  getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }
  getFileDownloadLink(file_url:string): string {
    return `${environment.api_url}${file_url}`
  } 


   onVendorDetails(id:number) {
          this.rfqRef = this.modalService.create({
            nzTitle: 'Vendor Details',
            nzContent: CetVendorDetailsComponent,
            nzFooter: null,
            nzWidth:'90vw',
            nzStyle: {
                top: '40px',
            },
            nzData: {
              id: id
            }
          });
     
   }

  onDetailsOpen(id:number){
   this.cetInvoicModalRef = this.modalService.create({
      nzTitle: 'Invoice Details',
      nzContent: CetInvoiceDetailsComponent,
      nzFooter:null,
      nzData: {
      id: id , name:''// 👈 This is how you pass data
     },
      nzStyle:{top:'50px'},
      nzWidth: '800px',
      nzClosable: true,
      // nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
    });

    this.cetInvoicModalRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });
  }

  onInvoiceEdit(invoice:any){
    this.cetInvoicModalRef = this.modalService.create({
      nzTitle: 'Edit Invoice',
      nzContent: CetInvoicesModalComponent,
      nzFooter:null,
      nzData: {
      eventData: invoice // 👈 This is how you pass data
     },
      nzWidth: '800px',
      nzStyle:{top:'50px'},
      nzClosable: true,
      nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
    });

    this.cetInvoicModalRef.afterClose.subscribe(result => {
      if (result === true) {
        this.getData();
      }
    });
  }

  deleteInvoice(id:number){
    this.loading = true
    this.vm.deleteInvoiceDetails(id)
  }

  invoiceDeleted(){
    this.getData()
  }

}
